export default __webpack_public_path__ + "static/media/2.c309ab0f.jpg";